/**
 * Parse a natural language "split transaction" instruction.
 *
 * Examples:
 * - "Split $50 to Late Fee"
 * - "split 25 to late fee"
 * - "$50 to Late Fee"
 *
 * Output is intentionally small and deterministic (no AI model calls):
 * - amount: positive number (magnitude only)
 * - name: trimmed label for the split line item
 */
function parseAmountMagnitude(text) {
  if (!text || typeof text !== "string") return null;
  // Support "$50", "50$", "50 dollars", "cost $50", etc.
  const m = text.match(/(?:cost\s+)?\$?\s*(\d+(?:\.\d{1,2})?)\s*\$?\s*(?:dollars?)?/i);
  if (!m) return null;
  const value = Number.parseFloat(m[1]);
  if (!Number.isFinite(value) || value <= 0) return null;
  return value;
}

export function parseNaturalSplitTransactionText(text) {
  const result = { amount: null, name: "" };
  if (!text || typeof text !== "string") return result;

  let remaining = text.trim();
  if (!remaining) return result;

  const normalizeName = (s) => {
    const cleaned = (s || "")
      .replace(/\s+/g, " ")
      .trim()
      .replace(/^[\s,:-]+/, "")
      .replace(/[\s,:-]+$/, "")
      .trim();
    if (!cleaned) return "";
    // Sentence-case: "LATE FEE" -> "Late fee", "late fee" -> "Late fee"
    return cleaned.charAt(0).toUpperCase() + cleaned.slice(1).toLowerCase();
  };

  // Remove leading "split" keyword (optional)
  remaining = remaining.replace(/^\s*split\s+/i, "").trim();

  const amount = parseAmountMagnitude(remaining);
  if (amount == null) return result;
  result.amount = amount;

  // Remove first amount occurrence
  remaining = remaining
    .replace(/(?:cost\s+)?\$?\s*\d+(?:\.\d{1,2})?\s*\$?\s*(?:dollars?)?/i, " ")
    .replace(/\s+/g, " ")
    .trim();

  // Expect "to <desc>" or "for <desc>" or just "<desc>"
  remaining = remaining.replace(/^(?:to|for)\s+/i, "").trim();

  result.name = normalizeName(remaining);
  return result;
}

